import React from 'react';
import { Row, Button, Col, Spinner } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Form from 'react-bootstrap/Form';
import MaterialTable from 'material-table';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import queryString from 'query-string';

const pageSizes = [5, 10, 25, 50, 100];
const searchBy = [
    { key: 'Link ID', value: 'orderId' },
    { key: 'Amount', value: 'linkAmount' }
];
class ProfileWalletLinks extends React.Component {
    _isMounted = false;

    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'orderId',
        loading: false,

        alert: 0,
        alertMessage: '',
        storeTag: '',
        backArrow: false,
        flag: 0,
        data: [],
        dataLinks: [],
        options: [],
        addAmount: '',
        orderNote: '',
        remarks: '',
        ShowFlashMessage: false,
        FlashMessage: '',
        transactionCharges: 2.5,
        currentTotalBalance: 0,
        withdrawAbaleAmount: 0,
    };

    dataArray = [];
    componentWillUnmount() {
        this._isMounted = false;
    }
    async componentDidMount() {
        this._isMounted = true;

        this.relaodData();
        
        
    }

    
    async relaodData() {
    
        let bodyData = {
            ProfileUniqeID: this.props.UniqeID,
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };
        let dataLinksItems = [];
        await RestServices.getAllCashFreeLinks(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (responseData) => {
               


                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if(responseData.list){
                    await responseData.list.forEach(async (transaction) => {
                        if (transaction.linkURL) {
                            dataLinksItems.push(transaction);
                        }
                    });
                }

                    dataLinksItems = dataLinksItems.sort(function (a, b) {
                        return a['Date'] > b['Date'] ? -1 : 1;
                    });

                    if (this._isMounted) {
                        this.setState({
                            dataLinks: dataLinksItems,
                            alert: 0,
                            loading: false
                        });
                    }

                    
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            flag: 2
                        });
                    }

                    

                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: 2,
                        loading: false,
                        data: [],
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.relaodData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.relaodData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ moveTo: 'Next' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ moveTo: 'Prev' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
    if(event.target.type === 'number' ){
		if (Number.isNaN(Number.parseFloat(event.target.value))) {
		}else{
		 this.setState({ [event.target.name]: parseFloat(event.target.value) });
		}
    }else{
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
        
    }
    };

    async loadData() {
        this.setState({ flag: 1 });
        await this.relaodData();
        if (this._isMounted) {
            this.setState({ flag: 2 });
        }
    }

    makeRandomId(length) {
        var result = '';
        var characters =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
            );
        }
        return result;
    }

    getBalanceAmount(item) {
        if (item['paidAmount'] > 0) {
        return '₹' + parseFloat(item['linkAmount'] - item['paidAmount']).toFixed(2);
        }else{
        return '₹' + parseFloat(item['linkAmount']).toFixed(2);
        }
    }

     

    getLinkAmount(itemAmount) {
        if (itemAmount > 0) {
            return '₹' + parseFloat(itemAmount).toFixed(2);
        } else {
            itemAmount = 0;
            return '₹' + parseFloat(itemAmount).toFixed(2);
        }
    }
    
  
    

    copyToClipboard = (rowData, FlashMessageString) => {
        
        var textField = document.createElement('textarea');
        textField.innerText = rowData.linkURL;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();

        if (this._isMounted) {
            this.setState({
                ShowFlashMessage: true,
                FlashMessage: FlashMessageString
            });
            setTimeout(() => {
                this.setState({ ShowFlashMessage: false, FlashMessage: '' });
            }, 5000);
        }
    };

    toggleChildPayments = (orderId) => {
        let highlightedItems = document.querySelectorAll('.childtable');
        highlightedItems.forEach((userItem) => {
            userItem.classList.add('hiddentable');
        });

        setTimeout(() => {
            let elem = document.querySelector('#' + orderId);
            elem.classList.remove('hiddentable');
        }, 100);
    };

    getChildTableRow = (dataLinks) => {
        let payment = [];
        if (dataLinks.linkPayments) {
            var payments = dataLinks.linkPayments;
            for (let i = 0; i < payments.length; i++) {
                if (i % 2 == 0) {
                    var classNameString = 'tableRowOdd';
                } else {
                    var classNameString = 'tableRowEven';
                }

                payment.push(
                    <tr key={i} className={classNameString}>
                        <td>Payment {i + 1}</td>
                        <td>{this.getLinkAmount(payments[i].amount)}</td>
                        <td>{getFormattedDateTime(payments[i].Date)}</td>
                        <td>{payments[i].orderId}</td>
                        <td>{payments[i].status}</td>
                    </tr>
                );
            }
        } else {
            payment.push(
                <tr>
                    <td colSpan="5" style={{ textAlign: 'center' }}>
                        No Records found...
                    </td>
                </tr>
            );
        }
        return payment;
    };

    getChildRow = (dataLinks) => {
        var orderId = dataLinks.orderId;

        let row = [];
        row.push(
            <tr id={orderId} key={orderId} className="childtable hiddentable">
                <td colSpan="5" style={{ padding: '0' }}>
                    <table className="table">
                        <thead>
                            <tr className="tableHead">
                                <td>Payment #</td>
                                <td>Transaction Amount</td>
                                <td>Payment Date</td>
                                <td>Transaction ID</td>
                                <td>Status</td>
                            </tr>
                        </thead>
                        <tbody>{this.getChildTableRow(dataLinks)}</tbody>
                    </table>
                </td>
            </tr>
        );
        return row;
    };
    render() {
        var payments = [];
        var dataLinks = this.state.dataLinks;
        for (let i = 0; i < dataLinks.length; i++) {
            let tableRow = '';
            if (i % 2 == 0) {
                var classNameString = 'tableRowOdd';
            } else {
                var classNameString = 'tableRowEven';
            }

            payments.push(
                <tr
                    id={'table_' + dataLinks[i].orderId}
                    key={'table_' + dataLinks[i].orderId}
                    className={classNameString}
                    onClick={(e) =>
                        this.toggleChildPayments(dataLinks[i].orderId)
                    }
                >
                    <td>
                        {dataLinks[i].orderId}{' '}
                        <span
                            style={{ cursor: 'pointer', color: 'blue' }}
                            onClick={(e) =>
                                this.copyToClipboard(
                                    dataLinks[i],
                                    'Payment Link copied to clipboard'
                                )
                            }
                        >
                            <img className="copy_icon" src={'copy-svgrepo-com.svg'} />
                        </span>
                        ({dataLinks[i]['Provider']?dataLinks[i]['Provider']:'CashFree'})
                    </td>
                    <td>{this.getLinkAmount(dataLinks[i].linkAmount)}</td>
                    <td>{this.getLinkAmount(dataLinks[i].paidAmount)}</td>
                    <td>{this.getBalanceAmount(dataLinks[i])}</td>
                    <td>{getFormattedDateTime(dataLinks[i].Date)}</td>
                </tr>
            );

            payments.push(this.getChildRow(dataLinks[i]));
        }


 
        return (
            
                        <div>
                            {this.state.ShowFlashMessage && (
                    <Alert className="FlashMessage" variant="success">
                        {this.state.FlashMessage}
                    </Alert>
                )}
                            <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>
                                    <Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>

                        <table className="table">
                            <thead>
                                <tr className="tableHead">
                                    <td>Link #</td>
                                    <td>Amount</td>
                                    <td>Amount Added</td>
                                    <td>Balance Amount</td>
                                    <td>Link Created</td>
                                </tr>
                            </thead>
                            <tbody>{payments}</tbody>
                        </table>

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.dataLinks.length <
                                    this.state.perPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {this.state.dataLinks.length >=
                                    this.state.perPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                        </div>
                    
                
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(ProfileWalletLinks);
